// extracted by mini-css-extract-plugin
module.exports = {"partnerLogo_container":"styles_partnerLogo_container__2RaWD","okbycar":"styles_okbycar__TthV7"};